import Vue from 'vue'

export default {
	namespaced: true,
	state: {
		articles: [],

		coop: {},
	},

	mutations:{
		/**
		 * [setArticles description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setArticles(state, payload) {
			state.articles = payload
		},

		/**
		 * [setCMSPerCoop description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setPerCoop(state, {coop_id, contents}) {
			if(!!coop_id) {
				state.coop[coop_id]=contents
			}
		},

		/**
		 * [addPerCoopContent description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		addPerCoopContent(state, {coop_id, content}) {
			if(!state.coop[coop_id]) {
				state.coop[coop_id]=[]
			}
			state.coop[coop_id].push(content)
		},

		/**
		 * [updatePerCoopContent description]
		 * @param  {[type]} state           [description]
		 * @param  {[type]} options.coop_id [description]
		 * @param  {[type]} options.content [description]
		 * @return {[type]}                 [description]
		 */
		updatePerCoopContent(state, {coop_id, content}) {
			for(let i=0; state.coop[coop_id].length; i++) {
				if(state.coop[coop_id][i].id==content.id) {
					state.coop[coop_id][i]=content
					break;
				}
			}
		},

		/**
		 * [removePerCoopContent description]
		 * @param  {[type]} state              [description]
		 * @param  {[type]} options.coop_id    [description]
		 * @param  {[type]} options.content_id [description]
		 * @return {[type]}                    [description]
		 */
		removePerCoopContent(state, {coop_id, content_id}) {
			for(let i=0; state.coop[coop_id].length; i++) {
				if(state.coop[coop_id][i].id==content_id) {
					state.coop[coop_id].splice(i, 1)
					break;
				}
			}
		}
	},
	getters:{
		/**
		 * [perCoop description]
		 * @param  {[type]} state   [description]
		 * @param  {[type]} coop_id [description]
		 * @return {[type]}         [description]
		 */
		perCoop(state) {
			return (coop_id) => {
				if(!coop_id) {
					return []
				}
				return state.coop[coop_id]||[]
			}
		},

		/**
		 * [articles description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		articles(state) {
			return state.articles
		}
	},
	actions: {
		/**
		 * [getCMSForMeber description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		getCMSForMeber({commit, getters}, payload) {
			if(getters['articles'].length) {
				return Promise.resolve(getters['articles'])
			}
			return this._vm.$http.get('/api/cms/member')
				.then(response=> {
					commit('setArticles', response.data)
					return response.data
				})
		},

		/**
		 * [fetchPercoop description]
		 * @param  {[type]} context [description]
		 * @return {[type]}         [description]
		 */
		fetchPercoop({commit, getters}, coop_id) {
			return new Promise((resolve, reject) => {
				if(!getters['perCoop'](coop_id).length) {
					// console.log()
					this._vm.$http.get('/api/cms/admin/'+coop_id)
						.then(response => {
							commit('setPerCoop', {coop_id: coop_id, contents: response.data})
							resolve(true)
						})
						.catch(response => {
							reject(response)
						})
				} else {
					resolve(true)
				}
			})
		}
	},

}